import { render, staticRenderFns } from "./MarkdownText.vue?vue&type=template&id=69dad473&"
import script from "./MarkdownText.vue?vue&type=script&lang=ts&"
export * from "./MarkdownText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports